// Hints for the "prices include VAT" choice on the review step: a worked
// example from the sheet, and how many products are priced exactly at their
// MRP while marked "before VAT" (MRP always includes VAT, so that is almost
// always the wrong choice).
import type { ImportPlan } from './validate.ts'

export interface VatHints {
  /** The first product to be added or updated that has a price. */
  example: { name: string; pricePaisa: number; taxRateId: string | null } | null
  /** Products priced at their MRP but marked "before VAT". */
  mrpEqualPrice: number
}

export function vatHints(plan: ImportPlan): VatHints {
  let example: VatHints['example'] = null
  let mrpEqualPrice = 0
  for (const r of plan.rows) {
    const v = r.values
    if ((r.status !== 'create' && r.status !== 'update') || !v) continue
    if (!example && v.sellPricePaisa > 0) {
      example = { name: v.name, pricePaisa: v.sellPricePaisa, taxRateId: v.taxRateId }
    }
    if (!v.priceIncludesTax && v.mrpPaisa != null && v.mrpPaisa === v.sellPricePaisa) {
      mrpEqualPrice++
    }
  }
  return { example, mrpEqualPrice }
}
